// extracted by mini-css-extract-plugin
export default {"dataGridContainer":"EmployeeList_dataGridContainer__iI1tr","title":"EmployeeList_title__mG7qF","settingsBtn":"EmployeeList_settingsBtn__KiHc9"};